module.exports = __webpack_public_path__ + "img/noticeT.cab04965.png";